import buildUrl from 'api-services/utils/buildUrl';
import genClientAuthCodes from 'hero-auth/genClientCodes';
import persistAuthStatus from 'hero-auth/persistAuthStatus';
export const initLogin = async (constAccessParams) => {
    const clientAuthCodes = await genClientAuthCodes();
    const queryParams = {
        response_type: 'code',
        client_id: constAccessParams.API_ID_CLIENT_ID,
        redirect_uri: window.location.origin,
        code_challenge: clientAuthCodes.code_challenge,
        state: clientAuthCodes.state
    };
    persistAuthStatus('loggingIn', clientAuthCodes);
    window.location.assign(buildUrl(constAccessParams.API_ID_HOSTNAME + 'login/', queryParams));
};
export default initLogin;
//# sourceMappingURL=initLogin.js.map